import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {OrderedItem} from "../interface/ordered-item";
import {OrderwiseWorkflow} from "../interface/orderwise-workflow";
import {AddOrderTransmissionService} from "../../raintree/transmission/order-transmission/order-transmission.service";
import {BloomsightService} from "../../bloomsight.service";
import {GlobalService} from "../../services/global.service";
import {OrderwiseWorkflowStep} from "../interface/orderwise-workflow-step";
import {OrderwiseWorkflowSubprocess} from "../interface/orderwise-workflow-subprocess";
import {CustomOrderItem} from "../interface/custom-order-item";

@Component({
  selector: 'fb-custom-order-item-process-status',
  templateUrl: './custom-order-item-process-status.component.html',
  styleUrls: ['./custom-order-item-process-status.component.scss']
})
export class CustomOrderItemProcessStatusComponent implements OnChanges {

	@Input()
	public product: CustomOrderItem = {} as CustomOrderItem;
	@Input()
	public orderId: number = 0;

	@Input()
	public workflow: OrderwiseWorkflow = {} as OrderwiseWorkflow;
	public showFeedback: boolean = false;
	public loading: boolean = true;
	public cdnLink: string = 'https://anuprerna-bloomscorp.s3.ap-south-1.amazonaws.com/bpm-feedback/';

	constructor(
		private _orderAPI: AddOrderTransmissionService,
		private _bloomsight: BloomsightService,
		private _userData: GlobalService,
	) {
	}

	ngOnChanges(changes: SimpleChanges) {
		if(this.workflow.workflowId) {
			this.workflow.steps.forEach(step => {
				let completedSubProcess = 0;
				step.subProcesses.forEach(sub => {
					if(sub.subProcessStatus === "COMPLETED") {
						completedSubProcess += 1;
						if(sub.hasApprovedFeedback) {
							this.toggleSection(step, sub);
						}
					}
					else if(sub.subProcessStatus === "IN_PROGRESS") {
						completedSubProcess += 0.4;
					}
				});
				step.stepProgress =  (completedSubProcess / step.subProcesses.length) * 100;
			})
		}
	}

	public toggleSection(step: OrderwiseWorkflowStep, subProcess: OrderwiseWorkflowSubprocess): void {
		this.getFeedback(step, subProcess);
	}

	public getFeedback(step: OrderwiseWorkflowStep, subProcess: OrderwiseWorkflowSubprocess): void {
		if(subProcess.hasApprovedFeedback) {
			this._orderAPI.orderItemProgressFeedback(
				subProcess.feedbackId,
				() => {
					this.loading = true;
				},
				() => {
				},
				(response) => {
					subProcess.elementFeedback = response;
					// subProcess.elementFeedback.image = "https://anuprerna-bloomscorp.s3.ap-south-1.amazonaws.com/home/hero/home-hero-1.png,https://anuprerna-bloomscorp.s3.ap-south-1.amazonaws.com/home/hero/home-hero-2.png,https://anuprerna-bloomscorp.s3.ap-south-1.amazonaws.com/home/hero/home-hero-3.png,https://anuprerna-bloomscorp.s3.ap-south-1.amazonaws.com/home/hero/home-hero-4.png"
					if(subProcess.elementFeedback.image) {
						subProcess.elementFeedback.images = subProcess.elementFeedback.image.split(',');
					}
					else {
						subProcess.elementFeedback.images = [];
					}
					// subProcess.elementFeedback.video = "https://anuprerna-bloomscorp.s3.ap-south-1.amazonaws.com/home/dyeing.mp4,https://anuprerna-bloomscorp.s3.ap-south-1.amazonaws.com/home/bts.mp4,https://anuprerna-bloomscorp.s3.ap-south-1.amazonaws.com/home/weaving.mp4,https://anuprerna-bloomscorp.s3.ap-south-1.amazonaws.com/home/stitching.mp4";
					if(subProcess.elementFeedback.video) {
						subProcess.elementFeedback.videosUrl = subProcess.elementFeedback.video.split(',');
					}
					else {
						subProcess.elementFeedback.videosUrl = [];
					}
					this.loading = false;
				},
				() => {
				},
				() => {
				}
			)
		}
	}

	public trackMediaView(url: string, mediaType: string): void {
		this._bloomsight.trackDataEvent(
			'679b79ca8f02e72fbfce1662',
			[
				{orderId: this.orderId},
				{email: this._userData.customerProfileData.tenant.email},
				{mediaTypeViewed: mediaType},
				{filename: url},
				{all: this.orderId + '-' + this._userData.customerProfileData.tenant.email + '-' + mediaType + '-' + url},
			],
			'Order Details- Interacting with Feedback Media'
		);
	}

}
